import { useRoutes } from "react-router-dom";
import PageNotFound from "../components/feedback/PageNotFound";
import { adminAreaRoute } from "./adminAreaRoute";
import { authRoute } from "./authRoute";
import { dashboardRoute } from "./dashboardRoute";
import { kpiRoute } from "./kpiRoute";
import { projectRoute } from "./projectRoute";
import { publicRoute } from "./publicRoute";
import { strategicPlanningRoute } from "./strategicPlanningRoute";
import { workspaceRoute } from "./workspaceRoute";

const fallback = {
    path: "/*",
    element: <PageNotFound />,
};

export default function Routes() {
    return useRoutes([
        //
        publicRoute,
        authRoute,
        adminAreaRoute,
        dashboardRoute,
        workspaceRoute,
        strategicPlanningRoute,
        projectRoute,
        kpiRoute,
        fallback,
    ]);
}
